import {GridsterItem} from 'angular-gridster2';
import {DashboardDesignSetting} from './dashboard-design-setting';
import {ChartModel} from './chart';
import {ChartGridViewPermission} from './chartGridViewPermission.model';
import {PermissionInterface} from '../../shared/components/permissions/models/permissions-map.type';

export interface Dashboard {
  dashboardId: string;
  workspaceId: string;
  name: string;
  richName: string;
  pureName: string;
  imagePath: string;
  ownerId: string;
  creationTickTime: number;
  lastModifiedTickTime: number;
  updateTickTime: number;
  lastModifiedDataSourceTickTime: number;
  description: string;
  inactive: boolean;
  dashboardGroupId: string;
  view: number;
  creator: string;
  usersCount: number;
  charts: Partial<ChartModel>[];
  dashboardDesignSettings: DashboardDesignSetting;
  chartsGrid: DashboardGrid;
  chartsGridViewPermitted?: GridsterItem[];
  permissionsResponseMap?: PermissionInterface;
  permissions?: number[];
  isSuperAdmin?: boolean;
  userId?: string;
  noPermissionExist?: boolean;
  isBookmarked?: boolean;
  isBackButtonEnable: boolean;
}
export interface DashboardGrid {
  version: string;
  grid: GridsterItem[];
  layoutVersion?: string; // 0.0.0 default | 0.0.1 latest config
}

export enum EditDashboardTypeEnum{
  DRAFT='DRAFT',
  PUBLISH = 'PUBLISH'
}
